import _classCallCheck from '../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../@babel/runtime/helpers/esm/createClass.js';
import _possibleConstructorReturn from '../@babel/runtime/helpers/esm/possibleConstructorReturn.js';
import _assertThisInitialized from '../@babel/runtime/helpers/esm/assertThisInitialized.js';
import _get from '../@babel/runtime/helpers/esm/get.js';
import _getPrototypeOf from '../@babel/runtime/helpers/esm/getPrototypeOf.js';
import _inherits from '../@babel/runtime/helpers/esm/inherits.js';
import { ReactiveElement as u } from './node_modules/@lit/reactive-element/reactive-element.js';
export { ReactiveElement, defaultConverter, notEqual } from './node_modules/@lit/reactive-element/reactive-element.js';
import { render as D, noChange as T } from '../lit-html/lit-html.js';
export { html, noChange, nothing, render, svg } from '../lit-html/lit-html.js';

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var l, o;
var s = /*#__PURE__*/function (_t) {
  _inherits(s, _t);
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, arguments), _this.renderOptions = {
      host: _assertThisInitialized(_this)
    }, _this._$Do = void 0;
    return _this;
  }
  _createClass(s, [{
    key: "createRenderRoot",
    value: function createRenderRoot() {
      var t, e;
      var i = _get(_getPrototypeOf(s.prototype), "createRenderRoot", this).call(this);
      return null !== (t = (e = this.renderOptions).renderBefore) && void 0 !== t || (e.renderBefore = i.firstChild), i;
    }
  }, {
    key: "update",
    value: function update(t) {
      var i = this.render();
      this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), _get(_getPrototypeOf(s.prototype), "update", this).call(this, t), this._$Do = D(i, this.renderRoot, this.renderOptions);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var t;
      _get(_getPrototypeOf(s.prototype), "connectedCallback", this).call(this), null === (t = this._$Do) || void 0 === t || t.setConnected(!0);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var t;
      _get(_getPrototypeOf(s.prototype), "disconnectedCallback", this).call(this), null === (t = this._$Do) || void 0 === t || t.setConnected(!1);
    }
  }, {
    key: "render",
    value: function render() {
      return T;
    }
  }]);
  return s;
}(u);
s.finalized = !0, s._$litElement$ = !0, null === (l = globalThis.litElementHydrateSupport) || void 0 === l || l.call(globalThis, {
  LitElement: s
});
var n = globalThis.litElementPolyfillSupport;
null == n || n({
  LitElement: s
});
(null !== (o = globalThis.litElementVersions) && void 0 !== o ? o : globalThis.litElementVersions = []).push("3.3.3");

export { s as LitElement };
